import React from 'react';
import { Base, Typography } from 'lib/cortiUI';
export const SettingsSection = ({ title, children }) => {
    return (React.createElement(Base, { display: "flex", flexDirection: "column", gap: 4 },
        React.createElement(Base, null,
            React.createElement(Typography, { variant: "body2" }, title)),
        children));
};
